export default __webpack_public_path__ + "static/media/product-here.4edfb47d.jpg";